'use strict';

// export const showEditDialog = state => { state.editDialog.visible = true  };

//=================================================================================================================

// export const hideEditDialog = state => { state.editDialog.visible = false };

//=================================================================================================================

export const setEditCopy = (state, copy) => { state.editDialog.copy = copy };

//=================================================================================================================

export const clearEditCopy = state => { state.editDialog.copy = {} };
